<template>
  <div class="industryManagement common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">所属行业：</div>
          <div class="content">
            <el-input v-model="form.industryName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">状态</div>
          <div class="content">
            <el-select v-model="form.stat" placeholder="请选择">
              <el-option v-for="item in stateList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
    </div>
    <commonTable ref="industryManagementTable" />
    <addIndustryDialog
      :row-data="rowData"
      :add-industry-dialog-show="addIndustryDialogShow"
      @dialogClose="dialogCloseHandle"
      @addIndustryHandle="addIndustryHandle"
      @editIndustryHandle="editIndustryHandle"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { industryManagementApi } from './service';
import addIndustryDialog from './component/industryManagement/addIndustryDialog';

export default {
  data () {
    return {
      form: {},
      addIndustryDialogShow: false,
      rowData: {},
      stateList: [
        {
          label: '全部'
        },
        {
          label: '启用',
          val: 1
        },
        {
          label: '禁用',
          val: 0
        }
      ]
    };
  },
  components: {
    commonTable,
    addIndustryDialog
  },
  methods: {
    addIndustryHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      industryManagementApi.addIndustry(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.addIndustryDialogShow = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editIndustryHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      industryManagementApi.editIndustry(data).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.addIndustryDialogShow = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addIndustryDialogShow = true;
    },
    addBtn () {
      this.addIndustryDialogShow = true;
    },
    dialogCloseHandle () {
      this.addIndustryDialogShow = false;
      this.rowData = {};
    },
    stateChange (row) {
      let params = {
        id: row.id,
        stat: row.stat ? 0 : 1
      };
      this.$store.commit('setSubPageLoading', true);
      industryManagementApi.editIndustry(params).then(res => {
        if (res.status === '200') {
          this.searchBtn();
          this.$message.success('操作成功');
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    searchBtn () {
      this.$refs.industryManagementTable.pageData.pageNum = 1;
      this.$refs.industryManagementTable.getTableData({ url: '/management/industry-list', params: this.form });
    },
    reset () {
      this.form = {};
      this.searchBtn();
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('所属行业')
          ._width('10%')
          ._data('industryName')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建人')
          ._width('8%')
          ._data('createUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('10%')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('最近更新人')
          ._width('8%')
          ._data('updateUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('最近更新时间')
          ._width('6%')
          ._data('updateTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('状态')
          ._width('8%')
          ._data('stat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <span>{ row[column.property] ? '启用' : '禁用' }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('8%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.stateChange(row); }}>
                    { row.stat ? '禁用' : '启用' }
                  </el-button>
                  <el-button type="text" onClick={() => { this.editHandlen(row); }}>
                    编辑
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.industryManagementTable.setColumn(column);
      this.$refs.industryManagementTable.loadTable({ url: '/management/industry-list', listKey: 'list' });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>
</style>
